import React from 'react'
import { Loader2 } from 'lucide-react'

import { cn } from '@/lib/utils'
import { Button } from '@/ui/button'

type WalletActionButtonProps = React.ComponentProps<typeof Button> & {
  loading?: boolean
}

/** Botón con spinner y estilo de carga para acciones wallet/on-chain. */
export function WalletActionButton({
  loading,
  disabled,
  className,
  children,
  ...props
}: WalletActionButtonProps) {
  return (
    <Button
      {...props}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={cn('gap-2', loading && 'wallet-action-button--busy', className)}
    >
      {loading ? <Loader2 className="size-5 shrink-0 animate-spin" aria-hidden /> : null}
      {children}
    </Button>
  )
}

type WalletActionNativeButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean
}

/** Variante nativa para estilos Nutrimatic que no usan el Button de UI. */
export function WalletActionNativeButton({
  loading,
  disabled,
  className,
  children,
  type = 'button',
  ...props
}: WalletActionNativeButtonProps) {
  return (
    <button
      {...props}
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={cn('inline-flex items-center justify-center gap-2', loading && 'wallet-action-button--busy', className)}
    >
      {loading ? <Loader2 className="size-4 shrink-0 animate-spin" aria-hidden /> : null}
      {children}
    </button>
  )
}
